export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13098.5f8e5134.jpg";